import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AutoComplete from "./AutoComplete";

export default function FormDialog(props) {
  const { open, close, lang, dir } = props;

  function handleClose() {
    close();
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <AutoComplete lang={lang} dir={dir} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
